import React from "react";
import styled from "styled-components";

const black = "#0d0d0d";
const blackSoft = "#141414";
const green = "#2a960d";
const greenBright = "#37c313";
const greenDark = "#1e7009";
const text = "#f2f2f2";
const textMuted = "#a8a8a8";

const Page = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;

  @media (max-width: 480px) {
    padding: 32px 14px;
  }
`;

const ErrorCard = styled.section`
  width: 100%;
  max-width: 560px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px 36px;
  background-color: ${blackSoft};
  border: 1px solid ${green};
  border-radius: 8px;

  @media (max-width: 480px) {
    padding: 36px 22px;
    gap: 14px;
  }
`;

const IconWrapper = styled.div`
  color: ${greenBright};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: ${text};

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const Message = styled.p`
  font-size: 1.05rem;
  line-height: 1.6;
  color: ${text};
  max-width: 42ch;

  @media (max-width: 480px) {
    font-size: 0.98rem;
  }
`;

const Hint = styled.p`
  font-size: 0.95rem;
  line-height: 1.5;
  color: ${textMuted};
  max-width: 44ch;

  @media (max-width: 480px) {
    font-size: 0.88rem;
  }
`;

const Button = styled.button`
  margin-top: 16px;
  appearance: none;
  border: none;
  border-radius: 6px;
  background-color: ${green};
  color: #fff;
  font-size: 1.05rem;
  font-weight: 600;
  font-family: inherit;
  letter-spacing: 0.02em;
  padding: 16px 40px;
  min-height: 52px;
  min-width: 220px;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    transform 0.1s ease;

  &:hover {
    background-color: ${greenBright};
  }

  &:active {
    background-color: ${greenDark};
    transform: scale(0.97);
  }

  &:focus-visible {
    outline: 3px solid ${greenBright};
    outline-offset: 3px;
  }

  @media (max-width: 480px) {
    width: 100%;
    min-width: 0;
    padding: 15px 24px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:active {
      transform: none;
    }
  }
`;

export default function BodyBettingsNotAllowed() {
  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <>
      <style>
        {`

      body{
          background-color: #0d0d0d!important;
      }

      .App{
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        }
      `}
      </style>

      <Page>
        <ErrorCard role="alert" aria-labelledby="error-title">
          <IconWrapper aria-hidden="true">
            <svg
              viewBox="0 0 96 96"
              width="88"
              height="88"
              fill="none"
              stroke="currentColor"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M48 12 L78 24 V44 C78 64 48 84 48 84 C48 84 18 64 18 44 V24 L48 12 Z" />
              <line x1="36" y1="38" x2="60" y2="62" />
              <line x1="60" y1="38" x2="36" y2="62" />
            </svg>
          </IconWrapper>

          <Title id="error-title">Acesso não permitido</Title>

          <Message>
            Sua sessão pode ter sido encerrada ou o acesso bloqueado. Isso
            acontece quando sua conta é logada em outro computador ou
            dispositivo, ou quando o seu plano expira.
          </Message>
          <Hint>
            Clique no botão abaixo para recarregar a página. Assim faremos uma
            nova verificação e você saberá exatamente o que aconteceu.
          </Hint>

          <Button type="button" onClick={handleGoHome}>
            Recarregar página
          </Button>
        </ErrorCard>
      </Page>
    </>
  );
}
